module.exports = __webpack_public_path__ + "static/media/female.69037cb7.svg";